import { DataBean } from "../DataBean";

export class GuideFreightTypeConstants extends DataBean {

    public async getTransportGuideFreightTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportGuideFreightTypeConstants_Number", [args]);
    }

}